import axios from 'axios'
import { Toast } from 'vant'

const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000
})

// 请求拦截
http.interceptors.request.use(
  config => {
    // 从localStorage中获取真实的openid
    const openid = localStorage.getItem('openid');
    if (openid) {
      config.headers.openid = openid;
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截
http.interceptors.response.use(
  response => {
    const res = response.data
    if (response.status !== 200) {
      Toast.fail(response.statusText || '错误')
      return Promise.reject(new Error(response.statusText || '错误'))
    } else {
      return res
    }
  },
  error => {
    Toast.fail(error.message || '请求失败')
    return Promise.reject(error)
  }
)

export default http 